import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
export const frontmatter = {
  "title": "Template - Many families have trouble repaying student debt",
  "lead": "Student loans have become an increasingly popular instrument to promote affordable access to tertiary education. They are currently available in over 70 countries, to varying degrees. The average share of tertiary students receiving a public or government-sponsored student loan in 19 mostly high-income countries was 40%, ranging from 1% in Switzerland to 42% in South Africa and 84% in New Zealand",
  "layout": "focus",
  "article": "finance",
  "year": 2017
};
function _createMdxContent(props) {
  const _components = {
    h2: "h2",
    h4: "h4",
    hr: "hr",
    p: "p",
    ..._provideComponents(),
    ...props.components
  }, {Aside, BackLink, FocusDetails, FocusImage, FocusThemeList, FocusTitle, Header, ReferenceButton, Share} = _components;
  if (!Aside) _missingMdxReference("Aside", true);
  if (!BackLink) _missingMdxReference("BackLink", true);
  if (!FocusDetails) _missingMdxReference("FocusDetails", true);
  if (!FocusImage) _missingMdxReference("FocusImage", true);
  if (!FocusThemeList) _missingMdxReference("FocusThemeList", true);
  if (!FocusTitle) _missingMdxReference("FocusTitle", true);
  if (!Header) _missingMdxReference("Header", true);
  if (!ReferenceButton) _missingMdxReference("ReferenceButton", true);
  if (!Share) _missingMdxReference("Share", true);
  return _jsxs(_Fragment, {
    children: [_jsxs(Header, {
      children: [_jsx(BackLink, {
        name: "focusPosts",
        children: "All focuses"
      }), _jsx(Share, {
        message: "test",
        disableEmbed: true
      })]
    }), "\n", _jsxs(FocusDetails, {
      url: "https://unesdoc.unesco.org/ark:/48223/pf0000379875/PDF/379875eng.pdf.multi.page=272",
      children: [_jsx(FocusTitle, {
        children: "Template Focus Article"
      }), _jsx(_components.p, {
        children: "Student loans have become an increasingly popular instrument to promote affordable\naccess to tertiary education. They are currently available in over 70 countries,\nto varying degrees. The average share of tertiary students receiving a public or\ngovernment-sponsored student loan in 19 mostly high-income countries was 40%, ranging\nfrom 1% in Switzerland to 42% in South Africa and 84% in New Zealand."
      }), _jsx(FocusImage, {
        size: "small",
        src: "0-fig_1.png",
        alt: "Almost all students receive a loan in some countries, almost none in others",
        href: "https://unesdoc.unesco.org/ark:/48223/pf0000379875/PDF/379875eng.pdf.multi.page=272"
      }), _jsx(_components.p, {
        children: "Often, however, student loans fall short of their promises of increased access and affordability. In Brazil, of the 2.2 million new student loans issued between 2009 and 2015, fewer than half translated into new enrolments; the majority of new loans were taken by students who were already enrolled or would have enrolled anyway (Brazil Ministry of Economy, 2017). In the United States, much of the increase in national student debt fed tuition spikes rather than new enrolments (Lucca et al., 2017).Student loans may also have different uptake rates by population group or programme type. Studies show that the risk-averse, who may be over-represented in some ethnic or immigrant groups or among poorer households, are less likely to take on student loans (Boatman et al., 2017). In Japan, debt aversion in poorer families diverts students from general to vocational high schools, hindering their prospect of entering tertiary education (Furuta, 2021)."
      })]
    }), "\n", _jsxs(Aside, {
      mobilePlacement: "bottom",
      children: [_jsx(_components.h4, {
        id: "focuses-published-in-finance",
        children: "Focuses published in Finance"
      }), _jsx(_components.hr, {}), _jsx(FocusThemeList, {
        theme: "finance"
      })]
    }), "\n", _jsx(_components.h2, {
      id: "references",
      children: "References"
    }), "\n", _jsx(_components.p, {
      children: "The full list of references can be found at this link."
    }), "\n", _jsx(ReferenceButton, {
      url: "https://unesdoc.unesco.org/ark:/48223/pf0000379875/PDF/379875eng.pdf.multi.page=272",
      children: _jsx(_components.p, {
        children: "2021/2 GEM Report"
      })
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
